import { Injectable } from "@angular/core";
import { BaseApiService } from "./base-api.service";
import { firstValueFrom, map } from "rxjs";
import { IChangelog } from "../models/changelog.model";

@Injectable({
    providedIn: 'root'
})
export class ChangelogService extends BaseApiService {
    public async getChangelog(language: string): Promise<IChangelog> {
        var response = await firstValueFrom(this.get<IChangelog>(`api/v1/service/changelog?language=${language}`).pipe(map(x => ({
            ...x,
            releases: x.releases.map(r => (
                {
                    ...r,
                    date: new Date(r.date)
                }
            ))
        }))));
        return response;
    }

    public async hasUnseenUpdates(language: string): Promise<boolean> {
        return await firstValueFrom(this.get<boolean>('api/v1/account/changelog/unseen', { params: { language } }));
    }

    public async markSeen(): Promise<void> {
        await firstValueFrom(this.post<void>('api/v1/account/changelog/seen'));
    }
}